import React from "react";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";

export default function CrudButtons({
  tagDescription,
  setTagDescription,
  openSaveDialog,
  setDialogControl,
  openDeleteDialog,
  addTagToEvent,
}) {
  return (
    <>
      <Row style={{ marginTop: 16 }}>
        <Col md={12}>
          <Button color="primary" onClick={addTagToEvent}>
            Aplicar Etiqueta ao Evento
          </Button>
        </Col>
      </Row>
      <Row style={{ marginTop: 16 }}>
        <Col md={4}>
          <FormGroup>
            <Label>Descrição do template</Label>
            <Input
              type="text"
              value={tagDescription}
              onChange={(e) => setTagDescription(e.target.value)}
              placeholder="Nome do template..."
            />
          </FormGroup>
        </Col>
        <Col md={8} style={{ display: 'flex', alignItems: 'flex-end', gap: 8, paddingBottom: 16 }}>
          <Button color="success" onClick={openSaveDialog}>
            Salvar Novo Template
          </Button>
          <Button color="warning" onClick={() => setDialogControl({ open: true, type: 'update' })}>
            Atualizar Template
          </Button>
          <Button color="danger" onClick={openDeleteDialog}>
            Deletar Template
          </Button>
        </Col>
      </Row>
    </>
  )
}
